import TargetedMerchandise from './TargetedMerchandise.component';

export default TargetedMerchandise;